import { useCallback, useContext, useEffect, useRef } from "react";
import { FavoritesAPI } from "../../services/api/favorites";
import { store } from "../../components/Store";
import { STORAGE_KEYS } from "../../config/constants";

/**
 * Hook para cargar los libros favoritos de la cuenta del usuario.
 * @returns {Object} - Un objeto con una propiedad "load" que es una función as ncrona
 *    que carga los libros favoritos de la cuenta del usuario.
 */
export const useAccountFavoritesDataLoader = () => {
	const { dispatch, state } = useContext(store);
	const stateBooks = state?.userBooksData?.books;
	const load = async ({ abortSignal }) => {
		await FavoritesAPI.getAll({ abortSignal: abortSignal || null })
			.then((result) => {
				const ids = result?.map((book) => book?.idLibro);
				const books = stateBooks?.filter((book) => ids?.includes(book?.idLibro));
				dispatch({
					type: "CHANGE",
					path: "favoriteBooks",
					value: books,
				});
				console.log("Loading favorites from account", books);
			})
			.catch((error) => console.error(error));
	};
	return {
		load,
	};
};

/**
 * Hook para cargar los libros favoritos de la cuenta del usuario desde el storage.
 * @returns {Object} - Un objeto con una propiedad "load" que es una funci n as ncrona
 *    que carga los libros favoritos de la cuenta del usuario desde el storage.
 */
export const useStorageFavoritesDataLoader = () => {
	const { dispatch, state } = useContext(store);
	const stateBooks = state?.userBooksData?.books;
	const username = state?.username;
	const booksRef = useRef([]);

	useEffect(() => {
		booksRef.current = stateBooks;
	}, [stateBooks]);

	const load = async () => {
		let favs = [];
		const result = localStorage.getItem(STORAGE_KEYS.favorite_books_ids);
		try {
			favs = Array.isArray(JSON.parse(result)?.[username])
				? JSON.parse(result)?.[username]
				: [];

			dispatch({
				type: "CHANGE",
				path: "favoriteBooks",
				value: booksRef.current?.filter((book) => favs.includes(book?.idLibro)),
			});

			console.log("Loading favorites from storage", favs);
		} catch (error) {
			console.error("Error loading favorites from storage", error);
		}
		return Promise.resolve(favs);
	};
	return {
		load,
	};
};
